import React from "react";
import Loader from "react-loader-spinner";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { imageAddress } from "../utils/useful";


class SearchGroupsModal extends React.Component {
    state = {
        data: [],
        selecteds: {}
    }

    componentDidMount() {
        // this.setState({ countries: countriesCode })
        // this.initData()


    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.initData()
        }
    }

    showModal = () => {
        this.initData()
        this.modal.showModal()
    }

    hideModal = () => {
        this.setState({ selecteds: {}, data: [] })
        this.modal.hideModal()

    }


    initData = () => {
        this.fetchData()
        this.setState({ selecteds: {} }, () => {
            if (Array.isArray(this.props.data)) {
                let selecteds = this.state.selecteds
                this.props.data.forEach(element => {
                    selecteds[element.thing?._id] = { _id: element.thing?._id, removed: false, init: true }
                });
            }

        })
    }



    fetchData = () => {

        this.setState({ isLoadingData: true })
        let body = {applet: '{{appletId}}', refUser: "{{refUser}}", user: "{{targetId}}", targetId: "{{targetId}}"}
       
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    if(typeof body[key] == 'object'){
                        body[key] = body[key]._id
                    }
                }
            }
        }

        // console.log(body)
       
        HttpServices.request('ygetConnectionGroups', body, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                return
            }
            // console.log(fetchResult)
            this.setState({ rawData: fetchResult.info, data: fetchResult.info })

        })
    }



    onDone = () => {
        this.setState({ isLoadingPost: true })
        let selecteds = this.state.selecteds
        let final = []
        // Object.values(selecteds).forEach(element => {
        // if (!element.init) {
        // final.push(element)
        // }
        // });

        this.props.onDone(selecteds,'groups', () => {
            this.setState({ isLoadingPost: false })
            this.modal.hideModal()
        })
    }


    search(value) {
        let data = this.state.rawData
        data = data.filter(e => e.name?.toLowerCase().includes(value.toLowerCase()))
        this.setState({ data })
    }

    changeSelect = (prop) => {
        let selecteds = this.state.selecteds
        if (!selecteds[prop._id] || selecteds[prop._id].removed) {
            selecteds[prop._id] = { _id: prop._id, name: prop.name }
        } else {
            delete selecteds[prop._id] //= { id: prop._id, fullname:prop.fullname,type:prop.type,username:prop.username,uType:'user',removed: true, init: false }
        }

        console.log(selecteds)

        this.setState({ selecteds })
    }

    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={400}>
                <div className=" w-100 h-100">
                    <div className="w-100 h-100 pb-5" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8, position: 'relative' }}>
                        <div className="w-100" style={{ zIndex: 1, padding: '7px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', position: '-webkit-sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

                            <p>Search</p>

                            <div className="flexc">
                                {this.state.isLoadingPost ? (
                                    <div className="flexcc px-2 h-100 pt-2">
                                        <Loader
                                            type={"Oval"}
                                            color={"#202020"}
                                            height={20}
                                            width={20}
                                        />
                                    </div>
                                ) : (
                                    <button onClick={() => this.onDone()} style={{ backgroundColor: '#ffffffde', borderRadius: 30 }}>
                                        <span className="text-normal px-2">Done</span>
                                    </button>
                                )}


                                <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close1.svg" alt="" />
                                </div>
                            </div>

                        </div>

                        <div className="w-100 mt-1 mb-1 pl-3 pr-3 pt-2 pb-1" style={{ position: 'sticky', position: '-webkit-sticky', top: 45, backgroundColor: '#fff' }}>
                            <input onChange={(e) => this.search(e.target.value)} placeholder="Search ..." className="w-100" style={{ height: 40, fontSize: 15, padding: '5px 15px', background: '#f2f6f8', borderRadius: 30, border: '1px solid #eee' }} />
                        </div>

                        <div className="w-100 text-start" >
                            {this.state.data.map((prop, index) => {
                                return (
                                    <div key={index} onClick={() => this.changeSelect(prop)} className="flexcb backHover pl-3 pr-4 pb-2 pt-2 cursor-pointer" style={{ borderBottom: '1px solid #f2f4f6', backgroundColor: (this.state.selecteds[prop._id] && this.state.selecteds[prop._id].removed != true) ? '#007aff20' : 'transparent' }}>
                                        <div className='flexcc mrd-3'>
                                            {/* <div>
                                                <img src={imageAddress(prop.image)} width="40px" style={{ borderRadius: 50, height: 40, objectFit: 'cover' }} />
                                            </div> */}
                                            {/* <p className="mrd-3 mt-1" style={{ fontSize: 20 }} >{prop.flag}</p> */}
                                            <div>
                                                <p className="text-small mx-2">{prop.name}</p>
                                                {/* <p className="text-smaller mx-2" style={{ color: '#789' }}>@{prop.username}</p> */}
                                                {/* <p className="text-smaller mx-2" style={{ color: '#789' }}>{prop.type}</p> */}
                                            </div>
                                        </div>

                                    </div>
                                )
                            })}

                            {this.state.data?.length === 0 && (
                                <div className="text-center mt-5">
                                    <img src="/images/target.svg" width="50px" />
                                    <p className="text-center text-small text-bold">Found nothing</p>
                                    <p className="text-center text-smaller">Change your search options</p>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Modal >
        );

    }
}


export default SearchGroupsModal;
